import React from 'react';
import { formatTime, formatDate, formatDay } from '../utils/timeService';

/**
 * Header Component
 * Displays logo, developer info, current time and date
 */
const Header = ({ currentTime }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-8 md:mb-16 mt-16 md:mt-0">
      <div className="mb-4 md:mb-0">
        <img 
          src="https://cdn2.iconfinder.com/data/icons/weather-flat-14/64/weather02-512.png" 
          alt="Weather app logo" 
          className="w-12 md:w-16"
        />
        <p className="mt-0 pt-0 font-bold tracking-tight text-opacity-85 text-sm md:text-base">
          Dev by Mayank.DEv
        </p>
      </div>

      {/* Time and Date Display */}
      <div className="space-y-1 text-center md:text-right">
        <h1 className="text-4xl md:text-7xl font-extrabold mb-2 md:mb-4 text-transparent bg-clip-text bg-gradient-to-r from-white to-blue-200">
          {formatTime(currentTime)}
        </h1>
        <div className="flex-col space-y-1">
          <p className="text-xl md:text-3xl text-bold tracking-tight text-gray-300">
            {formatDate(currentTime)}
          </p>
          <p className="text-lg md:text-2xl text-bold text-gray-300">
            {formatDay(currentTime)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Header;
